import { IDiscoverMore } from "../../ISearch";

export const discoverMoreEn: Array<IDiscoverMore> = [
  {
    title: "Food Navigator",
    href: "/food-navigator",
    imageSrc:
      "https://i.dietdoctor.com/wp-content/uploads/2021/12/The-best-high-protein-foods-for-weight-loss-1.jpg?auto=compress%2Cformat&w=150&h=112&fit=crop"
  },
  {
    title: "Higher-satiety recipes",
    href: "/satiety/recipes",
    imageSrc:
      "https://i.dietdoctor.com/wp-content/uploads/2021/10/How-to-get-started-on-a-high-protein-diets.jpg?auto=compress%2Cformat&w=150&h=112&fit=crop"
  }
];
